import ncNanoId from "utils/ncNanoId";

const otherPageChildMenus = [
  {
    id: ncNanoId(),
    href: "/admin/users",
    name: "All Registered Users",
  },
  {
    id: ncNanoId(),
    href: "/admin/bookings",
    name: "All Bookings",
  },
  {
    id: ncNanoId(),
    href: "/admin/analytics",
    name: "Business Analytics",
  },
  {
    id: ncNanoId(),
    href: "/admin/leads",
    name: "Leads Page",
  },
];
export const NAVIGATION_DEMO = [
  {
    id: ncNanoId(),
    href: "/",
    name: "Home",
    // type: "dropdown",
    isNew: true,
  },
  {
    id: ncNanoId(),
    href: "/admin/analytics",
    name: "Admin",
    type: "dropdown",
    children: otherPageChildMenus,
    isAdmin: true,
  },
  {
    id: ncNanoId(),
    href: "/home",
    name: "Bookings",
    isNew: true,
  },
  {
    id: ncNanoId(),
    href: "/gallery",
    name: "Gallery",
    isNew: true,
  },
  {
    id: ncNanoId(),
    href: "/nearby",
    name: "Near By",
    isNew: true,
  },
  {
    id: ncNanoId(),
    href: "/rental-income",
    name: "Rental Income",
    isNew: true,
  },
  {
    id: ncNanoId(),
    href: "/location",
    name: "Location",
    isNew: true,
  },
  {
    id: ncNanoId(),
    href: "/contact",
    name: "Contact Us",
  },
];
